// Sets up the API client for interacting with your backend.
// For your API reference, visit: https://docs.gadget.dev/api/manos
import { Client } from "@gadget-client/manos";

export const api = new Client();